import {
  formatEuroConSimbolo,
  formatPrecioVentaConEuro,
} from "./moneyParse";

/** Valores numéricos desde ficha propiedad → campos expediente. */
export function finanzasNumericasDesdePropiedad(prop = {}) {
  const num = (v) => (v != null && v !== "" && Number.isFinite(Number(v)) ? Number(v) : null);
  return {
    precio_venta: num(prop.precio_venta ?? prop.precio),
    precio_propietario: num(prop.precio_propietario),
    honorarios: num(prop.honorarios_euros ?? prop.honorarios),
    honorarios_iva: num(prop.iva_euros ?? prop.honorarios_iva),
    comision_comprador: num(prop.comision_comprador),
    comision_comprador_iva: num(prop.comision_comprador_iva),
    comision_propietario: num(prop.comision_propietario),
    comision_propietario_iva: num(prop.comision_propietario_iva),
    honorarios_colaborador: num(prop.honorarios_colaborador),
    honorarios_colaborador_iva: num(prop.honorarios_colaborador_iva),
    honorarios_incluidos: prop.honorarios_incluidos === true,
  };
}

/** Formatea finanzas para inputs del expediente (miles + €). */
export function finanzasFormateadasDesdePropiedad(prop = {}) {
  const n = finanzasNumericasDesdePropiedad(prop);
  const ent = (v) => (v == null ? "" : formatPrecioVentaConEuro(v));
  const eur = (v) => (v == null ? "" : formatEuroConSimbolo(v));
  return {
    precio_venta: ent(n.precio_venta),
    precio_propietario: ent(n.precio_propietario),
    honorarios: eur(n.honorarios),
    honorarios_iva: eur(n.honorarios_iva),
    comision_comprador: eur(n.comision_comprador),
    comision_comprador_iva: eur(n.comision_comprador_iva),
    comision_propietario: eur(n.comision_propietario),
    comision_propietario_iva: eur(n.comision_propietario_iva),
    honorarios_colaborador: eur(n.honorarios_colaborador),
    honorarios_colaborador_iva: eur(n.honorarios_colaborador_iva),
    honorarios_incluidos: n.honorarios_incluidos,
  };
}

const CLAVES_FINANZAS = [
  "precio_venta", "precio_propietario",
  "comision_comprador", "comision_comprador_iva",
  "comision_propietario", "comision_propietario_iva",
  "honorarios", "honorarios_iva",
  "honorarios_colaborador", "honorarios_colaborador_iva",
];

/** Fusiona finanzas de propiedad si el expediente no está bloqueado manualmente. */
export function mergeFinanzasExpediente(prev, fin, { precios_manual = false } = {}) {
  if (precios_manual || !fin) return {};
  const out = {};
  for (const k of CLAVES_FINANZAS) {
    if (fin[k] != null && fin[k] !== "") out[k] = fin[k];
  }
  if (fin.honorarios_incluidos != null && prev.honorarios_incluidos == null) {
    out.honorarios_incluidos = fin.honorarios_incluidos;
  }
  return out;
}
